// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36l-_","top":"styles_top__2978V","left":"styles_left__3yIFD","description":"styles_description__15uWR"};